import { SiteContextConfig } from '@spartacus/core';
import { EnvironmentConfiguration } from '../../../environments/models/environment.model';

export const customSiteContextConfig = (env: EnvironmentConfiguration): SiteContextConfig => ({
  context: env.commerceContext,
});
